import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const rootElement = document.getElementById("root")!;

const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

if (rootElement.innerHTML.trim() !== "") {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
